<template>
  <section class="organize-workspace">
    <!-- 顶部操作区 -->
    <table-toolbar :search.sync="search" :show-refresh="true" :show-export="true" :show-column-settings="true" :columns="columnOptions" :visible-columns.sync="visibleColumns" :default-columns="defaultColumns" :fixed-columns="['# ID', '组织名称', '操作']" @refresh="handleReset" @export="handleExport">
      <template slot="left">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddCompany" class="btn-action">新增组织</el-button>
      </template>
    </table-toolbar>

    <!-- 表格主体 -->
    <table-page :loading="organizeTableLoading" :empty="filteredData.length === 0" :show-top-pagination="false" :show-bottom-pagination="false" @retry="fetchData">
      <el-table
        :data="filteredData"
        stripe
        style="width: 100%"
        class="premium-table"
      >
        <el-table-column key="col-id" prop="id" width="90">
          <template slot="header">
            <span class="premium-header-title"><span class="header-icon-hash">#</span> ID</span>
          </template>
          <template slot-scope="scope">
            <span class="cell-id">{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-name" prop="name" min-width="160">
          <template slot="header">
            <span class="premium-header-title">组织名称</span>
          </template>
          <template slot-scope="scope">
            <el-link type="primary" class="cell-channel-name" @click="handleCheckCompany(scope.row, scope.$index)">
              {{ scope.row.name }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column key="col-company" v-if="visibleColumns.includes('company')" prop="company" min-width="130">
          <template slot="header">
            <span class="premium-header-title">所属企业</span>
          </template>
          <template slot-scope="scope">
            <span class="cell-text-main">{{ scope.row.company }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-biUrl" v-if="visibleColumns.includes('biUrl')" prop="biUrl" min-width="160">
          <template slot="header">
            <span class="premium-header-title">BI链接</span>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.biUrl" class="url-text">{{ scope.row.biUrl }}</span>
            <span v-else class="cell-text-gray">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-games" v-if="visibleColumns.includes('games')" prop="games" min-width="140">
          <template slot="header">
            <span class="premium-header-title">拥有游戏</span>
          </template>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.ownAll" size="mini" type="success" class="game-tag">全部游戏</el-tag>
            <el-tooltip v-else-if="scope.row.games && scope.row.games.length" placement="top">
              <div slot="content">
                <span v-for="item in scope.row.games" :key="item">{{ formatGame(item) }}<br/></span>
              </div>
              <el-tag size="mini" type="info" class="game-tag">{{ scope.row.games.length }} 个游戏</el-tag>
            </el-tooltip>
            <span v-else class="cell-text-gray">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-remarks" v-if="visibleColumns.includes('remarks')" prop="remarks" min-width="160" show-overflow-tooltip>
          <template slot="header">
            <span class="premium-header-title">备注</span>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.remarks">{{ scope.row.remarks }}</span>
            <span v-else class="cell-text-gray">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-createdAt" v-if="visibleColumns.includes('createdAt')" prop="createdAt" width="165">
          <template slot="header">
            <span class="premium-header-title">创建时间</span>
          </template>
          <template slot-scope="scope">
            <span class="cell-text-gray">{{ formatTime(scope.row, null, scope.row.createdAt) }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-updatedAt" v-if="visibleColumns.includes('updatedAt')" prop="updatedAt" width="165">
          <template slot="header">
            <span class="premium-header-title">修改时间</span>
          </template>
          <template slot-scope="scope">
            <span class="cell-text-gray">{{ formatTime(scope.row, null, scope.row.updatedAt) }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-actions" width="80" align="center">
          <template slot="header">
            <span class="premium-header-title">操作</span>
          </template>
          <template slot-scope="scope">
            <el-dropdown @command="cmd => handleActionCommand(cmd, scope.row, scope.$index)" trigger="hover">
              <el-button size="mini" class="action-btn" circle icon="el-icon-more-outline"></el-button>
              <el-dropdown-menu slot="dropdown" class="premium-dropdown-menu">
                <el-dropdown-item command="edit">
                  <i class="el-icon-edit"></i> 编辑组织
                </el-dropdown-item>
                <el-dropdown-item command="delete" style="color: #ef4444;">
                  <i class="el-icon-delete" style="color: #ef4444;"></i> 删除组织
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </table-page>

    <!-- 新增/编辑弹窗 -->
    <form-drawer :visible.sync="organizeDialogFormVisible" :title="organizeStatus ? '新增组织' : '编辑组织'" :icon="organizeStatus ? 'el-icon-plus' : 'el-icon-edit-outline'" :loading="saveLoading" width="640px" @save="handleClickSubmitBtn">
      <el-form :model="organizeForm" :rules="rules" ref="ruleForm" label-position="right" label-width="150px" size="small" class="drawer-horizontal-form">
            <el-form-item label="组织名称（唯一）" prop="name"><el-input v-model.trim="organizeForm.name" placeholder="请输入唯一组织名称"></el-input></el-form-item>
            <el-form-item label="所属企业"><el-input v-model.trim="organizeForm.company" placeholder="请输入所属企业名称"></el-input></el-form-item>
            <el-form-item label="BI链接" prop="biUrl"><el-input v-model.trim="organizeForm.biUrl" placeholder="请输入 http:// 或 https:// 开头的链接"></el-input></el-form-item>
            <el-form-item label="拥有游戏">
              <el-checkbox v-model="organizeForm.ownAll">全部游戏</el-checkbox>
              <el-select
                v-if="!organizeForm.ownAll"
                v-model="organizeForm.games"
                filterable clearable multiple collapse-tags
                style="margin-left: 16px; width: calc(100% - 90px);"
                placeholder="请选择游戏列表"
              >
                <el-option v-for="item in gameMap" :key="item[0]" :label="item[1].id + '-' + item[1].name" :value="item[1].id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注"><el-input type="textarea" v-model.trim="organizeForm.remarks" placeholder="请输入备注信息" :rows="3"></el-input></el-form-item>
      </el-form>
    </form-drawer>
  </section>
</template>

<script>
import api from '@/api/channel'
import filter from '@/filter'
import TableToolbar from '@/components/TableToolbar/index.vue'
import TablePage from '@/components/TablePage/index.vue'
import FormDrawer from '@/components/FormDrawer/index.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'organize',
  components: { TableToolbar, TablePage, FormDrawer },
  created () {
    this.fetchData()
  },
  computed: {
    gameMap () {
      return this.$store.getters.appMap
    },
    // 模糊搜索过滤
    filteredData () {
      const s = this.search
      if (!s) return this.organizeData
      return this.organizeData.filter(item =>
        Object.keys(item).some(key => String(item[key]).toLowerCase().includes(s.toLowerCase()))
      )
    },
    columnOptions () {
      return [
        { prop: 'company', label: '所属企业' },
        { prop: 'biUrl', label: 'BI链接' },
        { prop: 'games', label: '拥有游戏' },
        { prop: 'remarks', label: '备注' },
        { prop: 'createdAt', label: '创建时间' },
        { prop: 'updatedAt', label: '修改时间' }
      ]
    },
    defaultColumns () {
      return this.columnOptions.map(item => item.prop)
    }
  },
  data () {
    const validateName = (rule, value, callback) => {
      const isHasName = this.organizeData.some((item, i) => item.name === value && this.index !== i)
      if (value === '') {
        callback(new Error('请输入名称'))
      } else {
        if (isHasName) {
          callback(new Error('名称已经存在，请换一个'))
        } else {
          callback()
        }
      }
    }
    const validateUrl = (rule, value, callback) => {
      if (value && !value.startsWith('http://') && !value.startsWith('https://')) {
        callback(new Error('请输入有效的URL'))
      } else {
        callback()
      }
    }
    const rules = {
      name: [{ validator: validateName, trigger: 'blur', required: true }],
      biUrl: [{ validator: validateUrl, trigger: 'blur' }]
    }
    return {
      rules,
      search: '',
      visibleColumns: ['company', 'biUrl', 'games', 'remarks', 'createdAt', 'updatedAt'],
      organizeData: [],
      index: '',
      organizeStatus: false, // false 修改 true 新增
      organizeTableLoading: false,
      organizeDialogFormVisible: false,
      saveLoading: false,
      organizeForm: {
        name: '',
        company: '',
        biUrl: '',
        games: [],
        remarks: '',
        ownAll: false
      }
    }
  },
  methods: {
    fetchData () {
      this.organizeTableLoading = true
      api.httpOrganizeData().then(res => {
        this.organizeData = [...res]
        this.organizeData.forEach(item => {
          item.games = JSON.parse(item.games)
        })
      }).finally(() => {
        this.organizeTableLoading = false
      })
    },
    handleReset () {
      this.search = ''
      this.fetchData()
    },
    // 添加组织
    handleAddCompany () {
      this.initForm()
      this.organizeDialogFormVisible = true
      this.organizeStatus = true
    },
    // 查看/修改 组织
    handleCheckCompany (row, index) {
      this.index = index
      this.organizeStatus = false
      this.organizeForm = { ...row }
      this.organizeDialogFormVisible = true
    },
    // 点击提交按钮
    handleClickSubmitBtn () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.handleSubmitForm()
        } else {
          return false
        }
      })
    },
    // 提交表单
    handleSubmitForm () {
      this.saveLoading = true
      const data = {
        id: this.organizeForm.id,
        type: this.organizeStatus ? 'post' : 'put',
        params: { ...this.organizeForm }
      }
      data.params.games = JSON.stringify(data.params.games)
      api.httpOrganizeData(data).then(res => {
        const data = { ...res }
        data.games = JSON.parse(data.games)
        this.organizeStatus ? this.organizeData.push(data) : this.organizeData.splice(this.index, 1, data)
        this.$message.success(this.organizeStatus ? '新增成功' : '修改成功')
        this.index = ''
        this.organizeStatus = false
        this.organizeDialogFormVisible = false
      }).finally(() => {
        this.saveLoading = false
      })
    },
    // 删除数据
    handleDeleteCompany (id, i) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          id,
          type: 'delete'
        }
        api.httpOrganizeData(data).then(response => {
          this.organizeData.splice(i, 1)
          this.$message.success('删除成功')
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 操作列下拉菜单分发
    handleActionCommand (command, row, index) {
      if (command === 'edit') {
        this.handleCheckCompany(row, index)
      } else if (command === 'delete') {
        this.handleDeleteCompany(row.id, index)
      }
    },
    initForm () {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.organizeForm = {
        name: '',
        company: '',
        biUrl: '',
        games: [],
        remarks: '',
        ownAll: false
      }
    },
    // 格式化游戏名称
    formatGame (gameId) {
      const app = this.gameMap.get(gameId * 1)
      return app ? app.id + '-' + app.name : gameId
    },
    // 格式化时间
    formatTime (row, col, cellValue) {
      return filter.formatTime(cellValue)
    },
    handleExport () {
      const rows = this.filteredData.map(row => ({ ...row, games: JSON.stringify(row.games) }))
      const worksheet = XLSX.utils.json_to_sheet(rows)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '组织管理')
      XLSX.writeFile(workbook, `组织管理-${this.$moment().format('YYYYMMDDHHmmss')}.xlsx`)
    }
  }
}
</script>

<style scoped>
.organize-workspace {
  padding: 16px 24px;
}

/* 过滤筛选卡片 */
.filter-card {
  margin-top: 0 !important;
  margin-bottom: 20px;
  padding: 16px 24px;
  border-radius: var(--border-radius-card);
  background: var(--bg-card);
  border: 1px solid #E2E8F0;
  box-shadow: var(--shadow-base);
}

.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.filter-left-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.filter-right-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-action {
  flex-shrink: 0;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  height: 32px;
  padding: 0 16px;
}

.btn-action:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.btn-reset {
  background-color: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  color: #64748B !important;
  height: 32px;
  padding: 0 16px;
  border-radius: 8px !important;
  font-weight: 500 !important;
}

.btn-reset:hover {
  background-color: #F1F5F9 !important;
  color: var(--text-main) !important;
  border-color: #CBD5E1 !important;
}

.btn-setting {
  flex-shrink: 0;
  background-color: #FFFFFF !important;
  border-color: #E2E8F0 !important;
  color: #64748B !important;
  border-radius: 8px !important;
  height: 32px;
  padding: 0 16px;
}

.btn-setting:hover {
  background-color: #F8FAFC !important;
  border-color: #CBD5E1 !important;
  color: var(--text-main) !important;
}

.search-input {
  width: 220px;
  flex-shrink: 0;
}

.search-input :deep(.el-input__inner) {
  border-radius: 8px;
  border-color: #E2E8F0;
  height: 32px;
  line-height: 32px;
  font-weight: 500;
  background-color: #FFFFFF;
  color: var(--text-main);
  transition: all 0.2s ease;
}

.search-input :deep(.el-input__inner:hover) {
  border-color: #CBD5E1;
}

.search-input :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

/* 列配置 Popover 内部样式 */
.popover-title {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--text-main);
  padding: 6px 4px;
}

.popover-divider {
  height: 1px;
  background: #E2E8F0;
  margin: 6px 0;
}

.popover-body-scroll {
  max-height: 250px;
  overflow-y: auto;
  padding: 4px;
}

.popover-body-scroll::-webkit-scrollbar {
  width: 4px;
}

.popover-body-scroll::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 2px;
}

.popover-body-scroll :deep(.el-checkbox) {
  display: block;
  margin-bottom: 8px;
  margin-right: 0;
}

/* 表格卡片样式 */
.table-card {
  padding: 20px;
  border-radius: var(--border-radius-card);
  background-color: var(--bg-card);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-base);
}

.premium-header-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: inherit;
}

.header-icon-hash {
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 13.5px;
  font-weight: 900;
  color: inherit;
}

.cell-id {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace !important;
  font-size: 12.5px !important;
  font-weight: 600;
  color: var(--text-muted);
}

.cell-channel-name {
  font-weight: 700 !important;
  font-size: 13.5px !important;
  text-decoration: none !important;
}

.premium-table {
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  font-size: 13px !important;
  color: var(--text-main) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif !important;
}

.premium-table::before {
  display: none !important;
}

.premium-table :deep(.el-table__header-wrapper) th,
.premium-table :deep(.el-table__fixed-header-wrapper) th,
.premium-table :deep(.el-table__fixed-right-header-wrapper) th,
.premium-table :deep(th.el-table__fixed-column) {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.premium-table :deep(.el-table__row) td {
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.premium-table :deep(.el-table__row) {
  transition: background-color 0.2s ease;
}

.premium-table :deep(.el-table__row:hover) td {
  background-color: var(--bg-hover) !important;
}

.premium-table :deep(.el-table__body tr.hover-row > td),
.premium-table :deep(.el-table__body tr.hover-row.current-row > td),
.premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

/* URL 文本 */
.url-text {
  font-size: 12px;
  color: #64748B;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

/* 游戏 Tag */
.game-tag {
  border-radius: 12px !important;
  font-weight: 600 !important;
}

/* 深色模式适配 */
html.dark .game-tag.el-tag--success {
  color: #34d399 !important;
  background-color: rgba(16, 185, 129, 0.15) !important;
  border-color: rgba(16, 185, 129, 0.3) !important;
}

html.dark .game-tag.el-tag--info {
  color: #60a5fa !important;
  background-color: rgba(37, 99, 235, 0.15) !important;
  border-color: rgba(37, 99, 235, 0.3) !important;
}

html.dark .url-text {
  color: var(--text-muted);
}

/* 辅助文本 */
.text-muted {
  color: #94a3b8;
  font-size: 13px;
}

/* 操作列三点图标 */
.action-btn {
  font-size: 12px;
  border: 1px solid #E2E8F0;
  color: #64748B;
  background: #ffffff;
  transition: all 0.2s ease;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: #F1F5F9;
  color: var(--text-main);
  border-color: #CBD5E1;
}

/* 弹窗样式 */
.premium-dialog :deep(.el-dialog) {
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

/* 表单样式 */
.org-premium-form :deep(.el-form-item__label) {
  font-weight: 600;
  color: var(--text-main);
  padding-bottom: 6px !important;
}

.org-premium-form :deep(.el-input__inner) {
  border-radius: 6px;
  border-color: #E2E8F0;
}

.org-premium-form :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
}

.org-premium-form :deep(.el-textarea__inner) {
  border-radius: 6px;
  border-color: #E2E8F0;
}

.org-premium-form :deep(.el-textarea__inner:focus) {
  border-color: var(--primary-color);
}

/* 保存按钮 */
.btn-save {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
}

.btn-save:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}
</style>
